/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Code_LabelInputs */

const en_auth_error_code_label = /** @type {(inputs: Auth_Error_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error code`)
};

const es_auth_error_code_label = /** @type {(inputs: Auth_Error_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de error`)
};

/**
* | output |
* | --- |
* | "Error code" |
*
* @param {Auth_Error_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_error_code_label = /** @type {((inputs?: Auth_Error_Code_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Code_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_error_code_label(inputs)
	return en_auth_error_code_label(inputs)
});